(function (angular) {
    'use strict';

    function config(FacebookProvider, $httpProvider, $translateProvider) {
        var lang = (navigator.userLanguage ||
        navigator.language ||
        navigator.browserLanguage ||
        navigator.systemLanguage);
        FacebookProvider.init('993028097483020');
        FacebookProvider.setLocale(lang);

        $httpProvider.defaults.cache = true;

        $translateProvider.translations('en', {
            UNIVERSAL_JUDGMENT: 'Universal Judgment',
            JUDGE_NOW: 'Judge Now',
            SUBMIT: 'Submit',
            DONE: 'Done',
            NEW_SCORE: 'New Score',
            WHY: 'Why is this judgment important for you? (max. 255 chars.)',
            APPEARANCE: 'Appearance',
            INTELLIGENCE: 'Intelligence',
            HONESTY: 'Honesty',
            PROFESSIONALISM: 'Professionalism',
            HELL: 'Hell',
            HEAVEN: 'Heaven',
            PURGATORY: 'Purgatory',
            HOME: 'home',
            SEARCH: 'search',
            RANK: 'rank',
            ME: 'me',
            BACK: 'back',
            CANCEL: 'cancel',
            JUDGMENTS: 'Judgments',
            NO_JUDGMENTS: 'No judgments yet, be the first to add one!',
            LATEST: 'Latest judged',
            TOP: 'Most judged',
            RECOMMENDED_FOR_YOU: 'Recommended for you!',
            KEYWORDS: 'universal judgment, universal judgement, universal, judgment, judgement, judgments, judgements, judge, anti-social network, anti-social, anti, social, network, ranking, rankings, rank, ranks, rating, ratings, rate, rates, evaluation, evaluations, comment, comments, star, stars, 5 starts, 5stars, the best, the worst, heaven, hell, purgatory, mario barone, renato cavallari, 2007',
            HOME_TITLE: 'Universal Judgment - The First Anti-Social Network',
            HOME_META_DESCRIPTION: 'Universal Judgment is the very first anti-social network, dating back to 2007. Use it to discover who is going where after the final judgement. Paradise, Purgatory or Hell? Where are you going? Judge before you get judged!',
            HOME_META_KEYWORDS: '',
            RANK_TITLE: 'Who is going to %RANK% according to Universal Judgment?',
            RANK_META_DESCRIPTION: '%RANK% ranking at Universal Judgment shows who is going to %RANK% after the final judgment. Where are you going?',
            RANK_META_KEYWORDS: '%RANK%',
            SEARCH_TITLE: 'Search the Universal Judgment ranking database',
            SEARCH_META_DESCRIPTION: 'Search the Universal Judgment Ranking database by entering a search term.',
            SEARCH_META_KEYWORDS: 'search, find, discover',
            PERSON_TITLE: '%NAME%\'s profile page at Universal Judgment',
            PERSON_META_DESCRIPTION: '%NAME%\'s profile page at Universal Judgment, see what others think about %NAME%. What do you think about %NAME%?',
            PERSON_META_KEYWORDS: '%NAME%, %NAME% profile, profile, profile page, personal page, personal profile',
            JUDGE_TITLE: 'Judge %NAME% now at Universal Judgment',
            JUDGE_META_DESCRIPTION: '%NAME%\'s judgment form at Universal Judgment. Do you have any opinion about %NAME%, any experience with %NAME%, share with us and help others!',
            JUDGE_META_KEYWORDS: '%NAME%, judge %NAME%, form, form page, judgment page, judge now, judge here',
        });
        $translateProvider.translations('it', {
            UNIVERSAL_JUDGMENT: 'Giudizio Universale',
            JUDGE_NOW: 'Giudica',
            SUBMIT: 'Invia',
            DONE: 'Fatto',
            NEW_SCORE: 'Nuovo punteggio',
            WHY: 'Scrivi una recensione (max. 255 carat.)',
            APPEARANCE: 'APPARENZA',
            INTELLIGENCE: 'INTELLIGENZA',
            HONESTY: 'ONEST&Aacute;',
            PROFESSIONALISM: 'PROFESSIONALIT&Aacute;',
            HELL: 'Inferno',
            HEAVEN: 'Paradiso',
            PURGATORY: 'Purgatorio',
            HOME: 'home',
            SEARCH: 'ricerca',
            RANK: 'rank',
            ME: 'me',
            BACK: 'indietro',
            CANCEL: 'chiudi',
            JUDGMENTS: 'Giudizi',
            NO_JUDGMENTS: 'Non ci sono ancora giudizi, puoi essere il primo da aggiungere',
            LATEST: 'Gli Ultimi giudicati',
            TOP: 'I più giudicati',
            RECOMMENDED_FOR_YOU: 'Consigliato per te!',
            KEYWORDS: 'giudizio, universale, giudizio universale, anti-social, anti, social, anti-social network, rete anti-social, classifica, classifiche, rating, ratings, rate, valutazione, votazione, punteggio, stars, stelle, i migliori, i peggiori, paradiso, inferno, purgatorio, giuizi, mario barone, renato cavallari',
            HOME_TITLE: 'Giudizio Universale - La prima rete anti-social',
            HOME_META_DESCRIPTION: 'Giudizio Universale è davvero la prima rete anti-social su internet, online dal 2007. Giudica prima di essere giudicato.',
            HOME_META_KEYWORDS: '',
            RANK_TITLE: 'Giudizio Universale - Classifica - %RANK%',
            RANK_META_DESCRIPTION: 'Giudizio Universale Classifica del %RANK%',
            RANK_META_KEYWORDS: '%RANK%',
            SEARCH_TITLE: 'Giudizio Universale - Ricerca',
            SEARCH_META_DESCRIPTION: 'Ricerca la classifica del Giudizio Universale',
            SEARCH_META_KEYWORDS: 'ricerca, trova, scopri',
            PERSON_TITLE: 'Profilo di %NAME%\'s su Giudizio Universale',
            PERSON_META_DESCRIPTION: 'Profile personale di %NAME%\'s su Giudizio Universale, scopri cosa dicono gli altri a rispetto di %NAME%.',
            PERSON_META_KEYWORDS: '%NAME%, profilo, valutazione, commenti, recensione',
            JUDGE_TITLE: 'Giudica %NAME% su Giudizio Universale',
            JUDGE_META_DESCRIPTION: 'Modulario di giudizio di %NAME%, condividi le tue opinione e sperienza a rispetto di %NAME%.',
            JUDGE_META_KEYWORDS: '%NAME%, giudica %NAME%, form, modulario, valutazione, commenti',
        });
        $translateProvider.translations('pt', {
            UNIVERSAL_JUDGMENT: 'Juízo Universal',
            JUDGE_NOW: 'Julgar',
            SUBMIT: 'Enviar',
            DONE: 'Pronto',
            NEW_SCORE: 'Novos Pontos',
            WHY: 'Porque este juízo é importante para você? (max. 255 carat.)',
            APPEARANCE: 'Aparência',
            INTELLIGENCE: 'Inteligencia',
            HONESTY: 'Honestidade',
            PROFESSIONALISM: 'Profissionalismo',
            HELL: 'Inferno',
            HEAVEN: 'Paraíso',
            PURGATORY: 'Purgatório',
            HOME: 'home',
            SEARCH: 'busca',
            RANK: 'rank',
            ME: 'eu',
            BACK: 'voltar',
            CANCEL: 'cancelar',
            JUDGMENTS: 'Julgamentos',
            NO_JUDGMENTS: 'Ainda não existem julgamentos, seja o primeiro a adicionar um!',
            LATEST: 'Últimos julgamentos',
            TOP: 'Mais julgados',
            RECOMMENDED_FOR_YOU: 'Recomendados!',
            KEYWORDS: 'juizo, universal, juizo universao, julgamento, anti-social, anti, social, rede, avaliacao, avaliacoes, estrelas, estrela, o melhor, o pior, paraiso, inferno, purgatorio, julgamentos, mario barone, renato cavallari',
            HOME_TITLE: 'Juízo Universal - A Primeira Rede Anti-Social',
            HOME_META_DESCRIPTION: 'O Juízo Universal é mesmo a primeira rede anti-social da internet, desde 2007 online. Julgue antes de ser julgado.',
            HOME_META_KEYWORDS: '',
            RANK_TITLE: 'Juízo Universal - Ranking - %RANK%',
            RANK_META_DESCRIPTION: 'Quem está no %RANK% de acordo com o Juízo Universal',
            RANK_META_KEYWORDS: '%RANK%',
            SEARCH_TITLE: 'Juízo Universal - Busca',
            SEARCH_META_DESCRIPTION: 'Busque no Ranking do Juízo Universal',
            SEARCH_META_KEYWORDS: 'procure, pesquise, discubra',
            PERSON_TITLE: 'Página do %NAME% no Juízo Universal',
            PERSON_META_DESCRIPTION: 'Página do %NAME% no Juízo Universal, veja o que os outros estão a dizer a respeito de %NAME%.',
            PERSON_META_KEYWORDS: '%NAME%, pagina %NAME%, %NAME% profile, profile, avaliacao, commentario, commentarios',
            JUDGE_TITLE: 'Julgue %NAME% no Juízo Universal',
            JUDGE_META_DESCRIPTION: 'Formulário de julgamento de %NAME% no Juízo Universal, dê a sua opinião e conte a sua experiencia com %NAME%.',
            JUDGE_META_KEYWORDS: '%NAME%, julgue %NAME%, julga %NAME%, form, formulario, avaliacao, avaliacoes, comentario, comentarios, estrela, estrelas',
        });
        $translateProvider.translations('hi', {
            UNIVERSAL_JUDGMENT: 'Universal Judgment',
            JUDGE_NOW: 'Judge Now',
            SUBMIT: 'Submit',
            DONE: 'Done',
            NEW_SCORE: 'New Score',
            WHY: 'Why is this judgment important for you? (max. 255 chars)',
            APPEARANCE: 'Apperance',
            INTELLIGENCE: 'Intelligence',
            HONESTY: 'Honesty',
            PROFESSIONALISM: 'Professionalism',
            HELL: 'Hell',
            HEAVEN: 'Heaven',
            PURGATORY: 'Purgatory',
            HOME: 'home',
            SEARCH: 'search',
            RANK: 'rank',
            ME: 'me',
            BACK: 'back',
            CANCEL: 'cancel',
            JUDGMENTS: 'Judgments',
            NO_JUDGMENTS: 'No judgments yet, be the first to add one!',
            LATEST: 'Latest judged',
            TOP: 'Most judged',
            RECOMMENDED_FOR_YOU: 'Recommended for you!',
            KEYWORDS: 'universal, judgment, universal judgment, universal judgement, judgement, anti-social, anti, social, anti-social network, rating, ratings, rate, stars, the best, the worst, heaven, hell, purgatory, judgments, judgment, mario barone, renato cavallari',
            HOME_TITLE: 'Universal Judgment - The First Anti-Social Network',
            HOME_META_DESCRIPTION: 'Universal Judgment is the very first anti-social network, dating back to 2007. Judge before you get judged.',
            HOME_META_KEYWORDS: '',
            RANK_TITLE: 'Universal Judgment - Ranking - %RANK%',
            RANK_META_DESCRIPTION: '%RANK% Universal Judgment Ranking',
            RANK_META_KEYWORDS: '%RANK%',
            SEARCH_TITLE: 'Universal Judgment - Search',
            SEARCH_META_DESCRIPTION: 'Search the Universal Judgment Ranking',
            SEARCH_META_KEYWORDS: 'search, find, discover',
            PERSON_TITLE: '%NAME%\'s Profile at Universal Judgment',
            PERSON_META_DESCRIPTION: '%NAME%\'s profile at Universal Judgment, see what others think about %NAME%.',
            PERSON_META_KEYWORDS: '%NAME%, %NAME% profile, profile, evaluation, comments',
            JUDGE_TITLE: 'Judge %NAME%\'s at Universal Judgment',
            JUDGE_META_DESCRIPTION: '%NAME%\'s judgment form at Universal Judgment, share your opinion and experience about %NAME%.',
            JUDGE_META_KEYWORDS: '%NAME%, judge %NAME%, form, evaluation, comments',

        });
        $translateProvider.translations('zh', {
            UNIVERSAL_JUDGMENT: '普遍判斷',
            JUDGE_NOW: '法官現在',
            SUBMIT: '提交',
            DONE: '完成',
            NEW_SCORE: '新分數',
            WHY: '為什麼這個判斷對你很重要? (最大255個字符)',
            APPEARANCE: '外形',
            INTELLIGENCE: '情報',
            HONESTY: '誠實',
            PROFESSIONALISM: '專業',
            HELL: '地獄',
            HEAVEN: '天堂',
            PURGATORY: '煉獄',
            HOME: '家',
            SEARCH: '搜索',
            RANK: '秩',
            ME: '我',
            BACK: '背部',
            CANCEL: '取消',
            JUDGMENTS: '判斷',
            NO_JUDGMENTS: '沒有判斷, 是第一個添加一個!',
            LATEST: '最新判斷',
            TOP: '最評判',
            RECOMMENDED_FOR_YOU: '為你推薦',
            KEYWORDS: '普遍的，判斷的，普遍的判斷，普遍的判斷，判斷，反社會，反社會，反社會網絡，評級，評級，率，星星，最好，最壞，天堂，地獄，審判，判斷，判斷',
            HOME_TITLE: '普遍判斷 - 第一反社會網絡',
            HOME_META_DESCRIPTION: '通用判斷是第一個反社會網絡，可追溯到2007年。法官在你得到判斷',
            HOME_META_KEYWORDS: '',
            RANK_TITLE: '普遍判斷 - 排行 - %RANK%',
            RANK_META_DESCRIPTION: '%RANK% 通用判斷排名',
            RANK_META_KEYWORDS: '%RANK%',
            SEARCH_TITLE: '普遍判斷 - 搜索',
            SEARCH_META_DESCRIPTION: '搜索普遍判斷排名',
            SEARCH_META_KEYWORDS: '搜索，查找，發現',
            PERSON_TITLE: '%NAME%在普遍判斷的概況',
            PERSON_META_DESCRIPTION: '%NAME%在普遍判斷的概況, 看看別人對%NAME%的看法.',
            PERSON_META_KEYWORDS: '%NAME%, %NAME%的個人資料, 簡介，評價，評論',
            JUDGE_TITLE: '法官%NAME%在普遍判斷',
            JUDGE_META_DESCRIPTION: '%NAME%在普遍判決中的判決形式, 分享您對%NAME%的意見和經驗.',
            JUDGE_META_KEYWORDS: '%NAME%, 法官%NAME%, 形式，評價，評論',
        });
        var langs = ['en', 'it', 'pt', 'zh', 'hi'];
        var lang = (navigator.userLanguage ||
        navigator.language ||
        navigator.browserLanguage ||
        navigator.systemLanguage).split('-')[0];
        if (langs.indexOf(lang) === -1) {
            lang = langs[0];
        }
        $translateProvider.preferredLanguage(lang);
        $translateProvider.useSanitizeValueStrategy(null);
    }

    // move to gulp config
    angular.apiHost = 'http://test.universaljudgment.com/api';

    angular.module('app', [
        'ui.router',
        'facebook',
        'pascalprecht.translate',
        'ngSanitize',
        'infinite-scroll'
    ]).config(config);
}(window.angular));

angular
    .module('app')
    .component('appPersonProfileName', {
        templateUrl: 'app/components/person-profile/person-name/person-name.template.html',
        controller: 'personController',
        controllerAs: 'ctrl'
    });

angular
    .module('app')
    .component('appPersonProfileImage', {
        templateUrl: 'app/components/person-profile/person-image/person-image.template.html',
        controller: 'personController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * The home page controller
     * @param $stateParams
     * @param peopleService
     * @param authService
     * @param $state
     * @constructor
     */
    function RankController($stateParams,
                            peopleService,
                            authService,
                            metaService,
                            $state,
                            $translate,
                            $filter) {
        this.state = $state;
        this.translate = $translate;
        this.filter = $filter;
        this._peopleService = peopleService;
        this._authService = authService;
        this._metaService = metaService;
        this.rank = $stateParams.rank;
        this.getPeople(this.rank);
        this.setMetaInfo(this.rank);
    }

    RankController.prototype.setMetaInfo = function (rank) {
        var replacements = {'%RANK%': this.translate.instant(this.filter('uppercase')(rank))};
        this._metaService.setTitle(this.translate.instant('RANK_TITLE'), replacements);
        this._metaService.setDescription(this.translate.instant('RANK_META_DESCRIPTION'), replacements);
        this._metaService.setKeywords(this.translate.instant('RANK_META_KEYWORDS'), replacements);
        this._metaService.appendKeywords(this.translate.instant('KEYWORDS'));
    };

    /**
     *
     * @type {Array}
     */
    RankController.prototype.people = [];

    /**
     *
     * @param rank
     */
    RankController.prototype.getPeople = function (rank) {
        var that = this;

        this._peopleService.getRank(rank).then(function (data) {
            return (that.people = data.data);
        }).catch(function () {
            throw Error('Get people API is not available');
        });
    };

    RankController.prototype.isActive = function (menuName) {
        var that = this;
        var menu = menuName.split(',');
        var menuIsActive = '';
        angular.forEach(menu, function (menuItem) {
            if (menuIsActive === '') {
                menuIsActive = (menuItem === that.menuActive) ? 'active' : '';
            }
        });
        return menuIsActive;
    };

    angular.module('app').controller('rankController', RankController);
}(window.angular));

angular
    .module('app')
    .component('appRank', {
        templateUrl: 'app/states/rank/rank.template.html',
        controller: 'rankController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * Person controller
     * @param {Object} $stateParams
     * @param {PersonService} personService
     * @constructor
     */
    function PersonController($stateParams,
                              personService,
                              judgmentsService,
                              metaService,
                              $state,
                              $location,
                              $translate) {
        this.location = $location;
        this.translate = $translate;
        this._personService = personService;
        this._judgmentsService = judgmentsService;
        this._metaService = metaService;
        this.isFormOpen = $state.current.name === 'judge';
        this.personSlug = $stateParams.slug;
        if (this.personSlug) {
            this.getPerson(this.personSlug);
            this.getJudgments(this.personSlug);
        }
        else {
            this.getMe();
        }
    }

    PersonController.prototype.setMetaInfo = function (name) {
        var replacements = {'%NAME%': name};
        if (this.isFormOpen) {
            this._metaService.setTitle(this.translate.instant('JUDGE_TITLE'), replacements);
            this._metaService.setDescription(this.translate.instant('JUDGE_META_DESCRIPTION'), replacements);
            this._metaService.setKeywords(this.translate.instant('JUDGE_META_KEYWORDS'), replacements);
        }
        else {
            this._metaService.setTitle(this.translate.instant('PERSON_TITLE'), replacements);
            this._metaService.setDescription(this.translate.instant('PERSON_META_DESCRIPTION'), replacements);
            this._metaService.setKeywords(this.translate.instant('PERSON_META_KEYWORDS'), replacements);
        }
        this._metaService.appendKeywords(this.translate.instant('KEYWORDS'));
    };

    /**
     *
     * @type {boolean}
     */
    PersonController.prototype.isFormOpen = false;

    /**
     *
     * @type {boolean}
     */
    PersonController.prototype.judgmentsLoaded = false;

    PersonController.prototype.person = {};
    PersonController.prototype.judgments = {};

    PersonController.prototype.getMe = function () {
        var that = this;
        this._personService.getMe().then(function (me) {
            that.setMetaInfo(me.data.name);
            return (that.person = me.data);
        }).catch(function () {
            throw Error('Get person API is not available');
        });
    };

    /**
     * Gets user info from API call
     * @param slug
     */
    PersonController.prototype.getPerson = function (slug) {
        var that = this;
        this._personService.getPerson(slug).then(function (person) {
            that.setMetaInfo(person.data.name);
            return (that.person = person.data);
        }).catch(function (err) {
            if (err.status === 404) {
                that.location.url('/404');
                return null;
            }
            throw Error('Get person API is not available');
        });
    };

    /**
     * Gets user judgment list from API call
     * @param slug
     */
    PersonController.prototype.getJudgments = function (slug) {
        var that = this;
        this._judgmentsService.getJudgments(slug).then(function (judgments) {
            that.judgmentsLoaded = true;
            return (that.judgments = judgments.data);
        }).catch(function () {
            throw Error('Get person API is not available');
        });
    };

    angular.module('app').controller('personController', PersonController);
}(window.angular));

angular
    .module('app')
    .component('appPerson', {
        templateUrl: 'app/states/person/person.template.html',
        controller: 'personController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * Person controller
     * @param {PersonService} personService
     * @param {AuthService} authService
     * @constructor
     */
    function MeController(personService,
                          authService) {
        this._personService = personService;
        this._authService = authService;

        this.getMe();
    }

    MeController.prototype.me = {};

    /**
     * Gets user info from API call
     */
    MeController.prototype.getMe = function () {
        var that = this;
        this._personService.getMe().then(function (me) {
            return (that.me = me.data);
        }).catch(function () {
            throw Error('Get person API is not available');
        });
    };

    MeController.prototype.setLogout = function () {
        this._authService.setLogout();
    };

    angular.module('app').controller('meController', MeController);
}(window.angular));

angular
    .module('app')
    .component('appMe', {
        templateUrl: 'app/states/me/me.template.html',
        controller: 'meController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * Person controller
     * @param {Object} $stateParams
     * @param {QualitiesService} qualitiesService
     * @param {JudgmentService} judgmentService
     * @param {PersonService} personService
     * @constructor
     */
    function JudgeController($stateParams,
                             qualitiesService,
                             judgmentService,
                             personService) {
        this._qualitiesService = qualitiesService;
        this._judgmentService = judgmentService;
        this._personService = personService;
        this.personSlug = $stateParams.slug;
        this.getQualities();
    }

    /**
     *
     * @type {undefined}
     */
    JudgeController.prototype.why = '';

    /**
     * Gets user info from API call
     * @return {Object}
     */
    JudgeController.prototype.getQualities = function () {
        var that = this;
        this._qualitiesService.getQualities().then(function (qualities) {
            return (that.qualities = qualities.data);
        }).catch(function () {
            throw Error('Get qualities API is not available');
        });
    };

    /**
     * Person qualities
     * @returns {Array}
     */
    JudgeController.prototype.setQualities = function () {
        var that = this;
        var userQualities = [];
        angular.forEach(that.qualities, function (value) {
            userQualities.push({
                id: value.id,
                score: parseInt(value.score, 10)
            });
        });
        return userQualities;
    };

    /**
     *
     * @param personData
     */
    JudgeController.prototype.sendPersonData = function (personData) {
        var that = this;
        that._judgmentService.sendJudgment(personData).then(function () {
            that.judgmentWasSent();
            that.isLoading = false;
        }).catch(function () {
            that.isLoading = false;
            throw Error('Person judgment was not sent');
        });
    };

    JudgeController.prototype.isLoading = false;

    JudgeController.prototype.submitForm = function () {
        var that = this;
        this.isLoading = true;

        this._personService.getPerson(this.personSlug).then(function (person) {
            var personData = {
                judged: person.data.id,
                qualities: that.setQualities(),
                why: that.why
            };
            that.sendPersonData(personData);
        }).catch(function () {
            throw Error('Get person API is not available');
        });

    };

    JudgeController.prototype.judgmentWasSent = function () {
        this.judgeSent = true;
        this.blur = 'blur';
        this.personTotalScore();
    };

    JudgeController.prototype.personTotalScore = function () {
        var that = this;
        this._personService.getPerson(this.personSlug).then(function (person) {
            that.personScoreTest = person.data.score;
        }).catch(function () {
            throw Error('Get person API is not available');
        });
    };

    angular.module('app').controller('judgeController', JudgeController);
}(window.angular));

angular
    .module('app')
    .component('appJudge', {
        templateUrl: 'app/states/judge/judge.template.html',
        controller: 'judgeController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * The home page controller
     * @param {PeopleService} peopleService
     * @param {AuthService} authService
     * @param {object} $state
     * @param {$rootScope} $rootScope
     * @constructor
     */
    function HomeController(peopleService,
                            authService,
                            metaService,
                            $state,
                            $rootScope,
                            $translate,
                            $filter) {
        this.translate = $translate;
        this.filter = $filter;
        this._peopleService = peopleService;
        this._authService = authService;
        this._metaService = metaService;
        this.isSearchOpen = $state.current.name === 'search';
        this.getPeople();
        this.getRecommendedPeople();
        this.getLatest();
        this.getTop();
        this.setMetaInfo();
    }

    HomeController.prototype.setMetaInfo = function () {
        if (this.isSearchOpen) {
            this._metaService.setTitle(this.translate.instant('SEARCH_TITLE'));
            this._metaService.setDescription(this.translate.instant('SEARCH_META_DESCRIPTION'));
            this._metaService.setKeywords(this.translate.instant('SEARCH_META_KEYWORDS'));
        }
        else {
            this._metaService.setTitle(this.translate.instant('HOME_TITLE'));
            this._metaService.setDescription(this.translate.instant('HOME_META_DESCRIPTION'));
            this._metaService.setKeywords(this.translate.instant('HOME_META_KEYWORDS'));
        }
        this._metaService.appendKeywords(this.translate.instant('KEYWORDS'));
    };

    /**
     *
     * @type {Array}
     */
    HomeController.prototype.people = [];

    /**
     *
     * @type {Array}
     */
    HomeController.prototype.latest = [];

    /**
     *
     * @type {Array}
     */
    HomeController.prototype.top = [];

    /**
     *
     * @type {boolean}
     */
    HomeController.prototype.isSearchOpen = false;

    HomeController.prototype.page = 1;
    HomeController.prototype.itemsPage = 8;
    HomeController.prototype.userSearch = '';
    HomeController.prototype.peopleTmp = [];
    HomeController.prototype.peopleAll = [];
    HomeController.prototype.peoplePage = [];
    HomeController.prototype.addPeopleToPage = function () {
        if (this.userSearch.length === 0) {
            this.people = this.peopleAll.slice(0, this.itemsPage * this.page++);
        }
    };

    HomeController.prototype.searchPeople = function () {
        if (this.userSearch.length) {
            if (!this.peopleTmp) {
                this.peopleTmp = this.people;
            }
            var that = this;
            this.people = this.filter('filter')(this.peopleAll, function(value, index, array) {
                var regexp = new RegExp('^' + that.userSearch, 'i');
                return value.name.match(regexp) !== null;
            });
            var morePeople = this.filter('filter')(this.peopleAll, function(value, index, array) {
                var regexp = new RegExp(' ' + that.userSearch, 'i');
                var notRegexp = new RegExp('^' + that.userSearch, 'i');
                return (value.name.match(notRegexp) === null && value.name.match(regexp) !== null);
            });
            this.people = this.people.concat(morePeople);
        }
        else {
            if (this.peopleTmp) {
                this.people = this.peopleTmp;
                this.peopleTmp = [];
            }
        }
    };

    HomeController.prototype.recommended = [];

    HomeController.prototype.getRecommendedPeople = function () {
        var that = this;

        this._peopleService.getRecommendedPeople(this.translate.preferredLanguage()).then(function (data) {
            return (that.recommended = data.data);
        }).catch(function () {
            throw Error('Get people API is not available');
        });
    };

    HomeController.prototype.getPeople = function () {
        var that = this;

        this._peopleService.getPeople().then(function (data) {
            that.peopleAll = data.data;
            that.addPeopleToPage();
            return true;
        }).catch(function () {
            throw Error('Get people API is not available');
        });
    };

    HomeController.prototype.getLatest = function () {
        var that = this;

        this._peopleService.getRank('latest').then(function (data) {
            return (that.latest = data.data);
        }).catch(function () {
            throw Error('Get people API is not available');
        });
    };

    HomeController.prototype.getTop = function () {
        var that = this;

        this._peopleService.getRank('top').then(function (data) {
            return (that.top = data.data);
        }).catch(function () {
            throw Error('Get people API is not available');
        });
    };

    angular.module('app').controller('homeController', HomeController);
}(window.angular));

angular
    .module('app')
    .component('appHome', {
        templateUrl: 'app/states/home/home.template.html',
        controller: 'homeController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    function Error404Controller() {}

    angular.module('app').controller('error404Controller', Error404Controller);
}(window.angular));

angular
    .module('app')
    .component('appError404', {
        templateUrl: 'app/states/error404/error404.template.html',
        controller: 'error404Controller',
        controllerAs: 'ctrl'
    });

/**
 * Created on 14/08/16.
 * @author Renato Cardoso <re2005@gmail.com>
 */

(function (angular) {
    'use strict';

    /**
     * The menu page controller
     * @param {AuthService} authService
     * @constructor
     */
    function PersonProfileController() {
    }

    angular.module('app').controller('personProfileController', PersonProfileController);
}(window.angular));

angular
    .module('app')
    .component('appPersonProfile', {
        templateUrl: 'app/components/person-profile/person-profile.template.html',
        controller: 'personController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * The menu page controller
     * @param $state
     * @param authService
     * @param $rootScope
     * @constructor
     */
    function MenuController($state, authService, $rootScope) {
        this.menuActive = $state.current.name;
        this._authService = authService;
        this._rootScope = $rootScope;
        this.logged = false;

        this.isSearchOpen = false;
    }

    MenuController.prototype.isActive = function (menuName) {
        var that = this;
        var menu = menuName.split(',');
        var menuIsActive = '';
        angular.forEach(menu, function (menuItem) {
            if (menuIsActive === '') {
                menuIsActive = (menuItem === that.menuActive) ? 'active' : '';
            }
        });
        return menuIsActive;
    };

    MenuController.prototype.facebookLogin = function () {
        if (!this._rootScope.logged) {
            this._authService.setFacebookLogin();
        }
    };

    angular.module('app').controller('menuController', MenuController);
}(window.angular));

angular
    .module('app')
    .component('appMenu', {
        templateUrl: 'app/components/menu/menu.template.html',
        controller: 'menuController',
        controllerAs: 'ctrl'
    });

(function (angular) {
    'use strict';

    /**
     * Person controller
     * @param {Object} $stateParams
     * @param {PersonService} personService
     * @constructor
     */
    function JudgeSentController($stateParams,
                                 personService) {
        this.$stateParams = $stateParams;
        this._personService = personService;

        // Bootstrap
        this.personTotalScore();
    }

    /**
     *
     * @returns {Numeric}
     */
    JudgeSentController.prototype.getPersonId = function () {
        return this.$stateParams.id;
    };

    JudgeSentController.prototype.personTotalScore = function () {
        var that = this;
        this._personService.getPerson(this.getPersonId()).then(function (person) {
            that.personScoreTest = person.data.score;
        }).catch(function () {
            throw Error('Get person API is not available');
        });
    };

    angular.module('app').controller('judgeSentController', JudgeSentController);
}(window.angular));

angular
    .module('app')
    .component('appJudgeSent', {
        templateUrl: 'app/components/judge-sent/judge-sent.template.html',
        controller: 'judgeController',
        controllerAs: 'ctrl'
    });

angular
    .module('app')
    .component('appHeader', {
        templateUrl: 'app/components/header/header.template.html'
    });

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $http
     */
    function QualitiesService($http) {
        this.$http = $http;
    }

    QualitiesService.prototype.constants = {
        apiHost: angular.apiHost + '/qualities'
    };

    QualitiesService.prototype.getQualities = function () {
        return this.$http({
            url: this.constants.apiHost
        });
    };

    angular.module('app').service('qualitiesService', QualitiesService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $http
     */
    function PersonService($http) {
        this.$http = $http;
    }

    PersonService.prototype.constants = {
        apiHost: angular.apiHost + '/person'
    };

    PersonService.prototype.getPerson = function (id) {
        return this.$http({
            url: this.constants.apiHost + '/' + id
        });
    };

    PersonService.prototype.getMe = function () {
        return this.$http({
            url: this.constants.apiHost
        });
    };

    angular.module('app').service('personService', PersonService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $http
     */
    function PeopleService($http) {
        this.$http = $http;
    }

    PeopleService.prototype.constants = {
        apiHost: angular.apiHost + '/people'
    };

    PeopleService.prototype.getPeople = function () {
        return this.$http({
            url: this.constants.apiHost
        });
    };

    PeopleService.prototype.getRecommendedPeople = function (language) {
        var params = {};
        params['recommended'] = language;
        return this.$http({
            url: this.constants.apiHost,
            params: params
        });
    };

    PeopleService.prototype.getRank = function (rank) {
        var params = {};
        params[rank] = true;
        return this.$http({
            url: this.constants.apiHost,
            params: params
        });
    };

    angular.module('app').service('peopleService', PeopleService);
}(window.angular));

(function (angular) {
    'use strict';

    function MetaService() {}

    MetaService.prototype.title = '';
    MetaService.prototype.description = '';
    MetaService.prototype.keywords = '';

    MetaService.prototype.replacePlaceholders = function (title, replacements) {
        if (!replacements) {
            return title;
        }
        return title.replace(/%\w+%/g, function (placeholder) {
            return replacements[placeholder] || placeholder;
        });
    };

    MetaService.prototype.setTitle = function (title, replacements) {
        title = this.replacePlaceholders(title, replacements);
        this.title = title;
    };

    MetaService.prototype.setDescription = function (description, replacements) {
        description = this.replacePlaceholders(description, replacements);
        this.description = description;
    };

    MetaService.prototype.setKeywords = function (keywords, replacements) {
        keywords = this.replacePlaceholders(keywords, replacements);
        this.keywords = keywords;
    };

    MetaService.prototype.appendKeywords = function (keywords) {
        if (this.keywords === '') {
            this.keywords = keywords;
        }
        else {
            this.keywords += ', ' + keywords;
        }
    };

    angular.module('app')
        .service('metaService', MetaService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $state
     */
    function MenuStateService($state) {
        this.$state = $state;
    }

    MenuStateService.prototype.getMenuState = function () {
    };

    angular.module('app')
        .service('menuStateService', MenuStateService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $http
     */
    function JudgmentsService($http) {
        this.$http = $http;
    }

    /**
     *
     * @type {{apiHost: string}}
     */
    JudgmentsService.prototype.constants = {
        apiHost: angular.apiHost + '/judgments'
    };

    JudgmentsService.prototype.getJudgments = function (id) {
        return this.$http({
            url: this.constants.apiHost + '/' + id
        });
    };

    angular.module('app').service('judgmentsService', JudgmentsService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {Object} $http
     */
    function JudgmentService($http) {
        this.$http = $http;
    }

    /**
     *
     * @type {{apiHost: string}}
     */
    JudgmentService.prototype.constants = {
        apiHost: angular.apiHost + '/judgment'
    };

    /**
     *
     * @returns {Promise}
     */
    JudgmentService.prototype.sendJudgment = function (data) {
        // Implement get cookie
        // var csrfToken = getCookie('csrftoken');
        // var config = {
        //     headers: {
        //         'X-CSRFToken': csrfToken
        //     }
        // };
        return this.$http.post(this.constants.apiHost, data);
        // change API to accept cross domain post
    };

    angular.module('app').service('judgmentService', JudgmentService);
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param $state
     * @param Facebook
     * @param personService
     * @param $rootScope
     * @constructor
     */
    function AuthService($http, $state, Facebook, personService, $rootScope) {
        this._state = $state;
        this._facebook = Facebook;
        this._personService = personService;
        this._rootScope = $rootScope;
        this.$http = $http;
    }

    AuthService.prototype.constants = {
        apiHost: angular.apiHost + '/logout'
    };

    AuthService.prototype.isFacebookConnected = function () {
        return this._facebook.getLoginStatus(function (response) {
            return response;
        });
    };

    AuthService.prototype.setFacebookCookie = function (accessToken) {
        var today = new Date();
        var expiry = new Date(today.getTime() + 30 * 24 * 3600 * 1000);
        document.cookie = 'fbat=' + accessToken + '; expires=' + expiry + '; path=/;';
    };

    AuthService.prototype.removeFacebookCookie = function () {
        document.cookie = 'fbat==;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };

    AuthService.prototype.handleFacebookLogin = function (response) {
        if (response.authResponse) {
            var accessToken = response.authResponse.accessToken;
            this.setFacebookCookie(accessToken);
            this._rootScope.logged = true;
        }
    };

    AuthService.prototype.setFacebookLogin = function () {
        var that = this;

        this._facebook.login(function (response) {
            that.handleFacebookLogin(response);
        });
    };

    AuthService.prototype.logout = function () {
        return this.$http.post(this.constants.apiHost);
    };

    AuthService.prototype.setLogout = function () {
        this.removeFacebookCookie();
        this.logout();
        this._rootScope.logged = false;
    };


    angular.module('app')
        .service('authService', AuthService);
}(window.angular));

(function (angular) {
    angular.module('app').filter('timeago', function () {
        return function (time, local, raw) {
            if (!time) {
                return 'never';
            }

            if (!local) {
                (local = Date.now());
            }

            if (angular.isDate(time)) {
                time = time.getTime();
            } else if (typeof time === 'string') {
                time = new Date(time).getTime();
            }

            if (angular.isDate(local)) {
                local = local.getTime();
            } else if (typeof local === 'string') {
                local = new Date(local).getTime();
            }

            if (typeof time !== 'number' || typeof local !== 'number') {
                return;
            }

            var offset = Math.abs((local - time) / 1000);
            var span = [];
            var MINUTE = 60;
            var HOUR = 3600;
            var DAY = 86400;
            var WEEK = 604800;
            var MONTH = 2629744;
            var YEAR = 31556926;

            if (offset <= MINUTE) {
                span = ['', raw ? 'now' : 'less than a minute'];
            } else if (offset < (MINUTE * 60)) {
                span = [Math.round(Math.abs(offset / MINUTE)), 'min'];
            } else if (offset < (HOUR * 24)) {
                span = [Math.round(Math.abs(offset / HOUR)), 'hr'];
            } else if (offset < (DAY * 7)) {
                span = [Math.round(Math.abs(offset / DAY)), 'day'];
            } else if (offset < (WEEK * 4)) {
                span = [Math.round(Math.abs(offset / WEEK)), 'week'];
            } else if (offset < (MONTH * 12)) {
                span = [Math.round(Math.abs(offset / MONTH)), 'month'];
            } else if (offset < (YEAR * 100)) {
                span = [Math.round(Math.abs(offset / YEAR)), 'year'];
            }

            span[1] += (span[0] === 0 || span[0] > 1) ? 's' : '';
            span = span.join(' ');

            if (raw === true) {
                return span;
            }
            return (time <= local) ? span + ' ago' : 'in ' + span;
        };
    });
}(window.angular));

(function (angular) {
    angular.module('app').filter('score', function () {
        return function (score) {
            return Math.floor(score/0.80);
        };
    });
}(window.angular));

(function (angular) {
    'use strict';

    /**
     *
     * @param {object} $cacheFactory
     * @return {{response: response}}
     * @constructor
     */
    function InvalidateCacheInterceptorFactory($cacheFactory) {

        return {
            response: function (res) {
                if (res.data['result'] === 'True') {
                    $cacheFactory.get('$http').removeAll();
                }
                return res;
            }
        };
    }

    angular.module('app')
        .factory('invalidateCacheInterceptor', InvalidateCacheInterceptorFactory)
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('invalidateCacheInterceptor');
        });
}(window.angular));


(function (angular) {
    angular.module('app').directive('back', [ '$window', '$location', '$rootScope', function ($window, $location, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('click', function () {
                    if ($rootScope.navigated) {
                        $window.history.back();
                    }
                    else {
                        $location.path('/');
                    }
                });
            }
        };
    }]);
}(window.angular));

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/header/header.template.html","<header>\n    <div class=\"header-wrap\">\n        <a href=\"/\">\n        <div class=\"logo\">\n            <span class=\"icon-logo\"></span>\n            <span class=\"icon-logo\"></span>\n        </div>\n        <h1>\n            Universal <span> Judgment</span>\n        </h1>\n        </a>\n    </div>\n</header>\n");
$templateCache.put("app/components/judge-sent/judge-sent.template.html","<div class=\"text-center row sent-judge\">\n    <div class=\"col-xs-12 text-center\">\n        <span class=\"font-md clearfix\">Another judgment done! Bless you!</span>\n    </div>\n\n    <div class=\"col-xs-12 text-center\">\n        <app-person-profile></app-person-profile>\n        <h1>New Score:</h1>\n        <h2 class=\"font-xxl\" data-ng-bind=\"ctrl.personScoreTest\"></h2>\n    </div>\n</div>\n\n<nav>\n    <a ui-sref=\"home\">FINISH</a>\n</nav>\n");
$templateCache.put("app/components/menu/menu.template.html","<div class=\"container-fluid\">\n    <nav ng-hide=\"mainMenu\" class=\"row\">\n        <a ui-sref=\"home\" class=\"col-xs-3 col-sm-12 icon-home2\" data-ng-class=\"ctrl.isActive(\'home\')\">\n            <span translate=\"HOME\" class=\"hidden-xs\"></span>\n        </a>\n        <a ui-sref=\"search\" class=\"col-xs-3 col-sm-12 icon-search2\" data-ng-class=\"ctrl.isActive(\'search\')\">\n            <span translate=\"SEARCH\" class=\"hidden-xs\"></span>\n        </a>\n        <a ui-sref=\"rank({rank:\'purgatory\'})\" class=\"col-xs-3 col-sm-12 icon-rank_off\" data-ng-class=\"ctrl.isActive(\'rank-menu,rank\')\">\n            <span translate=\"RANK\" class=\"hidden-xs\"></span>\n        </a>\n        <a ui-sref=\"me\" class=\"col-xs-3 col-sm-12 icon-user\" data-ng-class=\"ctrl.isActive(\'me\')\" data-ng-show=\"$root.logged\">\n            <span translate=\"ME\" class=\"hidden-xs\"></span>\n        </a>\n        <a href=\"/\" data-ng-click=\"ctrl.facebookLogin()\" class=\"col-xs-3 col-sm-12 icon-facebook\" data-ng-show=\"!$root.logged\">FACEBOOK</a>\n    </nav>\n</div>\n");
$templateCache.put("app/components/person-profile/person-profile.template.html","<div class=\"row user-info\" data-ng-model=\"ctrl.person\">\n    <div class=\"col-xs-4 col-xs-offset-1\">\n        <app-person-profile-image></app-person-profile-image>\n    </div>\n    <div class=\"col-xs-7\">\n        <app-person-profile-name></app-person-profile-name>\n    </div>\n</div>\n");
$templateCache.put("app/states/error404/error404.template.html","<app-header></app-header>\n\n<div class=\"container-fluid\">\n    <h1>404</h1>\n</div>\n<app-menu class=\"home\"></app-menu>\n");
$templateCache.put("app/states/home/home.template.html","<app-header></app-header>\n\n<div class=\"container-fluid home\" data-ng-class=\"{\'searchOn\': ctrl.isSearchOpen}\">\n\n    <div class=\"title\" data-ng-show=\"!ctrl.userSearch\">\n        <h1 translate=\"LATEST\"></h1>\n    </div>\n    <div class=\"user-list list-secondary\" data-ng-show=\"!ctrl.userSearch\">\n        <ul>\n            <li data-ng-repeat=\"person in ctrl.latest\">\n                <a ui-sref=\"person({slug:person.slug})\">\n                    <div class=\"user-image {{person.status}}\">\n                        <img src=\"{{person.img}}\" alt=\"{{person.name}}\">\n                    </div>\n                    <h2 class=\"font-xs user-name\" data-ng-bind=\"person.name\"></h2>\n                    <div class=\"stars stars{{person.score | score}}\">\n                        <span class=\"star0\"></span>\n                        <span class=\"star1\"></span>\n                        <span class=\"star2\"></span>\n                        <span class=\"star3\"></span>\n                        <span class=\"star4\"></span>\n                    </div>\n                    <span data-ng-bind=\"person.score\"></span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"title\" data-ng-show=\"!ctrl.userSearch\">\n        <h1 translate=\"TOP\"></h1>\n    </div>\n    <div class=\"user-list top-10\" data-ng-show=\"!ctrl.userSearch\">\n        <ul>\n            <li data-ng-repeat=\"person in ctrl.top\">\n                <a ui-sref=\"person({slug:person.slug})\">\n                    <div class=\"user-image {{person.status}}\">\n                        <img src=\"{{person.img}}\" alt=\"{{person.name}}\">\n                    </div>\n                    <h2 class=\"font-xs user-name\" data-ng-bind=\"person.name\"></h2>\n                    <div class=\"stars stars{{person.score | score}}\">\n                        <span class=\"star0\"></span>\n                        <span class=\"star1\"></span>\n                        <span class=\"star2\"></span>\n                        <span class=\"star3\"></span>\n                        <span class=\"star4\"></span>\n                    </div>\n                    <span data-ng-bind=\"person.score\"></span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"title\" data-ng-show=\"!ctrl.userSearch && ctrl.recommended.length\">\n        <h1 translate=\"RECOMMENDED_FOR_YOU\"></h1>\n    </div>\n\n    <div class=\"user-list\" data-ng-show=\"!ctrl.userSearch\">\n        <ul>\n            <li data-ng-repeat=\"person in ctrl.recommended\">\n                <a ui-sref=\"person({slug:person.slug})\">\n                    <div class=\"user-image {{person.status}}\">\n                        <img src=\"{{person.img}}\" alt=\"{{person.name}}\">\n                    </div>\n                    <h2 class=\"font-xs user-name\" data-ng-bind=\"person.name\"></h2>\n                    <div class=\"stars stars{{person.score | score}}\">\n                        <span class=\"star0\"></span>\n                        <span class=\"star1\"></span>\n                        <span class=\"star2\"></span>\n                        <span class=\"star3\"></span>\n                        <span class=\"star4\"></span>\n                    </div>\n                    <span data-ng-bind=\"person.score\"></span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"title\" data-ng-show=\"!ctrl.userSearch\">\n        <h1 translate=\"UNIVERSAL_JUDGMENT\"></h1>\n    </div>\n\n    <div class=\"user-list last-item\" data-ng-class=\"ctrl.isSearchOpen ? \'search top-10\' : \'\'\">\n        <ul infinite-scroll=\"ctrl.addPeopleToPage()\" infinite-scroll-distance=\"1\">\n            <li data-ng-repeat=\"person in ctrl.people\">\n                <a ui-sref=\"person({slug:person.slug})\">\n                    <div class=\"user-image {{person.status}}\">\n                        <img src=\"{{person.img}}\" alt=\"{{person.name}}\">\n                    </div>\n                    <h2 class=\"font-xs user-name\" data-ng-bind=\"person.name\"></h2>\n                    <div class=\"stars stars{{person.score | score}}\">\n                        <span class=\"star0\"></span>\n                        <span class=\"star1\"></span>\n                        <span class=\"star2\"></span>\n                        <span class=\"star3\"></span>\n                        <span class=\"star4\"></span>\n                    </div>\n                    <span data-ng-bind=\"person.score\"></span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"userSearch row\" data-ng-show=\"ctrl.isSearchOpen\">\n        <div class=\"col-xs-9 col-xs-offset-1 col-sm-9 col-md-7 col-lg-5\">\n            <input type=\"text\" data-ng-model=\"ctrl.userSearch\" data-ng-change=\"ctrl.searchPeople();\">\n        </div>\n        <div class=\"col-xs-1\">\n            <a href=\"/\" class=\"icon-close btn\"></a>\n        </div>\n    </div>\n\n    <footer>Universal Judgment - Copyright &copy; 2007</footer>\n</div>\n\n\n<app-menu class=\"home\"></app-menu>\n");
$templateCache.put("app/states/judge/judge.template.html","<app-header></app-header>\n\n<div class=\"container-fluid judge\">\n\n    <div class=\"loading\" data-ng-show=\"ctrl.isLoading\">\n        <span class=\"icon-spin3 animate-spin\"></span>\n    </div>\n\n    <div data-ng-show=\"ctrl.judgeSent\" class=\"popup\">\n        <div class=\"text-center row sent-judge\">\n            <div class=\"col-xs-12 text-center\">\n                <app-person-profile-image></app-person-profile-image>\n            </div>\n            <div class=\"col-xs-12\">\n                <h1 translate=\"NEW_SCORE\"></h1>\n                <h2 class=\"font-xxl\" data-ng-bind=\"ctrl.personScoreTest\"></h2>\n            </div>\n        </div>\n\n        <nav>\n            <a ui-sref=\"person({slug:ctrl.personSlug})\" translate=\"DONE\" class=\"col-xs-12 col-sm-12 btn icon-logo\"></a>\n        </nav>\n\n    </div>\n\n\n    <section data-ng-class=\"ctrl.blur\">\n\n        <app-person-profile></app-person-profile>\n\n        <div class=\"row form\">\n            <ul class=\"judge-list\">\n                <li data-ng-repeat=\"quality in ctrl.qualities\">\n                    <label class=\"col-xs-12\" translate=\"{{quality.name|uppercase}}\"></label>\n                    <div class=\"col-xs-3\">\n                        <span data-ng-show=\"focus\" class=\"judge-value\">\n                            {{ctrl.qualities[$index].score}}\n                        </span>\n                        <span class=\"icons-qualities\">\n                            <img data-ng-src=\"{{quality.img}}\">\n                        </span>\n                    </div>\n                    <div class=\"col-xs-9 col-xs-offset-3\">\n                        <input data-ng-focus=\"focus = true\" data-ng-blur=\"focus = false\" type=\"range\" min=\"0\" max=\"4\" data-ng-model=\"ctrl.qualities[$index].score\" data-ng-init=\"ctrl.qualities[$index].score = 2\">\n                    </div>\n                </li>\n            </ul>\n            <div class=\"col-xs-12 why\">\n                <h3 translate=\"WHY\"></h3>\n                <textarea name=\"why\" data-ng-model=\"ctrl.why\" rows=\"4\" maxlength=\"255\"></textarea>\n            </div>\n        </div>\n\n\n        <nav class=\"row\">\n            <a ui-sref=\"person({slug:ctrl.personSlug})\" class=\"col-xs-4 col-sm-12 icon-close\" translate=\"CANCEL\"></a>\n            <a data-ng-click=\"ctrl.submitForm()\" class=\"col-xs-8 col-sm-12 btn icon-forward\" translate=\"SUBMIT\"></a>\n        </nav>\n\n    </section>\n\n</div>\n");
$templateCache.put("app/states/me/me.template.html","<app-header></app-header>\n\n<div class=\"container-fluid person\">\n\n    <app-person-profile></app-person-profile>\n\n    <div class=\"row\">\n        <ul class=\"list-items\">\n            <li ng-repeat=\"(key, quality) in ctrl.me.qualities\">\n                <div class=\"col-xs-6 text-right\">\n                    {{quality.name}}\n                    <div class=\"qualities-icon\">\n                        <img ng-src=\"{{quality.img}}\">\n                    </div>\n                </div>\n                <div class=\"col-xs-4 col-xs-offset-2 font-lg score\">\n                    {{quality.score}}\n                </div>\n            </li>\n        </ul>\n    </div>\n    <div class=\"text-center\" data-ng-show=\"$root.logged\">\n        <a data-ng-click=\"ctrl.setLogout()\" class=\"btn btn-logout\">logout\n        </a>\n    </div>\n</div>\n\n<app-menu></app-menu>\n");
$templateCache.put("app/states/person/person.template.html","<app-header></app-header>\n\n<div class=\"container-fluid person\">\n\n    <app-person-profile></app-person-profile>\n\n    <div class=\"row\">\n        <ul class=\"list-items\">\n            <li ng-repeat=\"(key, quality) in ctrl.person.qualities\">\n                <div class=\"col-xs-6 text-right\">\n                    <span translate=\"{{quality.name|uppercase}}\"></span>\n                    <div class=\"qualities-icon\">\n                        <img ng-src=\"{{quality.img}}\">\n                    </div>\n                </div>\n                <div class=\"col-xs-4 col-xs-offset-2 font-lg score\">\n                    {{quality.score}}\n                </div>\n            </li>\n        </ul>\n\n        <h1 class=\"judgments-header\" translate=\"JUDGMENTS\" data-ng-show=\"ctrl.judgments.length\"></h1>\n        <ul class=\"list-judgments\">\n            <li data-ng-repeat=\"judgment in ctrl.judgments\">\n                <div class=\"user-image {{judgment.judge_status}}\">\n                    <img data-ng-src=\"{{judgment.judge_img}}\">\n                </div>\n                <h1 class=\"judge-name\">\n                    <a ui-sref=\"person({slug:judgment.judge_slug})\">{{judgment.judge}}</a>\n                    <time datetime=\"{{judgment.created}}\">{{judgment.created|timeago}}</time>\n                </h1> \n                <div class=\"stars stars{{judgment.score | score}}\">\n                    <span class=\"star0\"></span>\n                    <span class=\"star1\"></span>\n                    <span class=\"star2\"></span>\n                    <span class=\"star3\"></span>\n                    <span class=\"star4\"></span>\n                </div>\n                <p data-ng-if=\"judgment.why\" data-ng-bind=\"judgment.why\"></p>\n                 \n            </li>\n        </ul>\n\n        <h1 class=\"judgments-header\" translate=\"NO_JUDGMENTS\" data-ng-show=\"!ctrl.judgments.length && ctrl.judgmentsLoaded\"></h1>\n    </div>\n\n    <nav class=\"row\">\n        <a ng-href=\"#\" back class=\"col-xs-4 col-sm-12 icon-arrow-back\" translate=\"BACK\"></a>\n        <a ui-sref=\"judge({slug:ctrl.person.slug})\" class=\"col-xs-8 col-sm-12 btn icon-judges\" translate=\"JUDGE_NOW\">\n        </a>\n    </nav>\n\n</div>\n");
$templateCache.put("app/states/rank/rank.template.html","<app-header></app-header>\n\n<div class=\"container-fluid rank\">\n\n    <div class=\"title\">\n        <h1 translate=\"{{ctrl.rank|uppercase}}\"></h1>\n        <h2 data-ng-bind=\"ctrl.people.length\"></h2>\n    </div>\n    <div id=\"user-list\" class=\"last-item\">\n        <ul>\n            <li data-ng-repeat=\"person in ctrl.people | filter : userSearch\">\n                <a ui-sref=\"person({slug:person.slug})\">\n                    <div class=\"user-image {{person.status}}\">\n                        <img src=\"{{person.img}}\" alt=\"{{person.name}}\">\n                    </div>\n                    <h2 class=\"font-xs user-name\" data-ng-bind=\"person.name\"></h2>\n                    <div class=\"stars stars{{person.score | score}}\">\n                        <span class=\"star0\"></span>\n                        <span class=\"star1\"></span>\n                        <span class=\"star2\"></span>\n                        <span class=\"star3\"></span>\n                        <span class=\"star4\"></span>\n                    </div>\n                    <span data-ng-bind=\"person.score\"></span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"row rank-menu\">\n        <div class=\"col-xs-12 col-md-9 col-lg-6\">\n            <div class=\"row\">\n                <div class=\"col-xs-4\">\n                    <a ui-sref=\"rank({rank:\'hell\'})\" class=\"icon-emo-devil btn\" data-ng-class=\"{\'active\' : ctrl.rank === \'hell\'}\">\n                        <span translate=\"HELL\" class=\"hidden-xs\"></span>\n                    </a>\n                </div>\n                <div class=\"col-xs-4\">\n                    <a ui-sref=\"rank({rank:\'purgatory\'})\" class=\"icon-emo-sleep btn\" data-ng-class=\"{\'active\' : ctrl.rank === \'purgatory\'}\">\n                        <span translate=\"PURGATORY\" class=\"hidden-xs\"></span>\n                    </a>\n                </div>\n                <div class=\"col-xs-4\">\n                    <a ui-sref=\"rank({rank:\'heaven\'})\" class=\"icon-emo-saint btn\" data-ng-class=\"{\'active\' : ctrl.rank === \'heaven\'}\">\n                        <span translate=\"HEAVEN\" class=\"hidden-xs\"></span>\n                    </a>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n<app-menu class=\"home\"></app-menu>\n");
$templateCache.put("app/components/person-profile/person-image/person-image.template.html","<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"user-image {{ctrl.person.status}}\">\n            <img data-ng-src=\"{{ctrl.person.img}}\">\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/person-profile/person-name/person-name.template.html","<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <h1 class=\"user-name\" data-ng-bind=\"ctrl.person.name\"></h1>\n        <div class=\"stars stars{{ctrl.person.score | score}}\">\n            <span class=\"star0\"></span>\n            <span class=\"star1\"></span>\n            <span class=\"star2\"></span>\n            <span class=\"star3\"></span>\n            <span class=\"star4\"></span>\n        </div>\n        <h2 class=\"user-rate pull-left\" data-ng-bind=\"ctrl.person.score\"></h2>\n    </div>\n</div>\n");}]);
angular
    .module('app')
    .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('home', {
            url: '/',
            template: '<app-home></app-home>'
        })
        .state('search', {
            url: '/search',
            template: '<app-home></app-home>'
        })
        .state('person', {
            url: '/person/:slug',
            template: '<app-person></app-person>'
        })
        .state('judge', {
            url: '/judge/:slug',
            template: '<app-judge></app-judge>'
        })
        .state('me', {
            url: '/me',
            template: '<app-me></app-me>'
        })
        .state('rank-menu', {
            url: '/rank',
            template: '<app-rank></app-rank>'
        })
        .state('rank', {
            url: '/rank/{rank:hell|heaven|purgatory}',
            template: '<app-rank></app-rank>'
        })
        .state('error404', {
            url: '/404',
            template: '<app-error404></app-error404>'
        });
}


(function (angular) {
    'use strict';

    function run($rootScope, authService, metaService, Facebook) {

        // check if already navigated to to back button or homepage
        $rootScope.navigated = false;
        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.navigated = (from.name && from.name != 'judge');
        }); 

        $rootScope.metaService = metaService;

        $rootScope.$watch(
            function () {
                return Facebook.isReady();
            },
            function (newVal) {
                if (newVal) {
                    authService.isFacebookConnected().then(function (response) {
                        authService.handleFacebookLogin(response);
                    });
                }
            }
        );
    }

    angular.module('app')
        .run(run);
}(window.angular));


